import Button from '@mui/material/Button';
import React from 'react';

const SecondaryButton = props => (
  <Button
    {...props}
    fullWidth
    secondary
  />
);

SecondaryButton.propTypes = Button.propTypes;

export default SecondaryButton;
